<ng-template #itemTemplate let-item="item">
  <div class="permission-selection-panel-permission-name">
    <div class="line-ellipsis">{{ item.name }}</div>
  </div>
</ng-template>

<ng-template #selectionTemplate let-item="item">
  <div class="filter-name">{{ item.name }}</div>
</ng-template>

<ng-container [formGroup]="editorForm">
  <ca-selector
    #permissionSelector
    formControlName="editor"
    [url]="permissionSelectorOptions.url"
    [itemTemplate]="itemTemplate"
    [selectionTemplate]="selectionTemplate"
    [queryOperator]="permissionSelectorOptions.queryOperator"
    [queryField]="permissionSelectorOptions.queryField"
    [multiple]="'true'"
    [emptyText]="permissionSelectorOptions.emptyText"
    [showSelections]="permissionSelectorOptions.showSelections"
    [showClearSelections]="permissionSelectorOptions.showClearSelections"
    [showClearSelectionLink]="permissionSelectorOptions.showClearSelectionLink"
    [selectorPosition]="permissionSelectorOptions.selectorPosition"
    [styles]="{ width: '100%', 'border-width': '0px' }"
    [pageSize]="permissionSelectorOptions.pageSize"
    [currentPage]="permissionSelectorOptions.currentPage"></ca-selector>
</ng-container>
